{
  "confirmationNumber": "رقم التأكيد {number}",
  "dateTimeRange": "{date} من {startTime} إلى {endTime}"
}
